fragment AttachmentAssignmentFragment on AttachmentAssignment {
    id
    priority
    attachment {
        ...AttachmentFragment
    }
}